import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { triggerPriceTypeEnum } from '@flipster/apis/v2/trade/types';

import { ModalPriceBasisRow } from '../../../../shared/tpsl/modal-price-basis-row';
import { TpslTypeScope } from '../../../state';
import { instrumentBunja, parentPositionBunja } from '../../../state/base';
import { tpslModalInputBunja } from '../../state';

export const LimitPriceInput = () => {
  const {
    pricePrecisionAtom,
    quoteCurrencyAtom,
    limitPriceInputTextAtom,
    limitSecondaryAtom,
    onLimitPriceInputChange,
    onLimitSecondaryChange,
    addLimitPercent,
    tpslType,
    sideAtom,
  } = useBunja(limitPriceInputBunja);
  const t = useTranslations();
  const pricePrecision = useAtomValue(pricePrecisionAtom);
  const quoteCurrency = useAtomValue(quoteCurrencyAtom);
  const limitPriceInputValue = useAtomValue(limitPriceInputTextAtom);
  const limitSecondary = useAtomValue(limitSecondaryAtom);
  const side = useAtomValue(sideAtom);

  return (
    <ModalPriceBasisRow
      priceValue={limitPriceInputValue}
      onPriceChange={onLimitPriceInputChange}
      pricePrecision={pricePrecision}
      pricePlaceholder={t('Autogen_common.r251126.s_Enter_price')}
      // Limit has no triggerPriceType — hide Mark/Last (visual clone uses price-only left field).
      triggerPriceType={triggerPriceTypeEnum.mark}
      onTriggerPriceTypeChange={() => {}}
      showTriggerPriceTypeSelect={false}
      // Limit secondary is Change(%) only — no ROI/PnL dropdown.
      basisMode='change'
      onBasisModeChange={() => {}}
      showBasisSelect={false}
      secondaryValue={limitSecondary}
      onSecondaryChange={onLimitSecondaryChange}
      quoteCurrency={quoteCurrency}
      leg={tpslType}
      side={side}
      showQuickPercents
      onQuickPercent={addLimitPercent}
    />
  );
};

const limitPriceInputBunja = bunja(() => {
  const tpslType = bunja.use(TpslTypeScope);
  const { pricePrecisionAtom, quoteCurrencyAtom } = bunja.use(instrumentBunja);
  const { sideAtom } = bunja.use(parentPositionBunja);
  const {
    limitPriceInputTextAtom,
    limitSecondaryAtom,
    setLimitPriceInputText,
    onLimitSecondaryChange,
    addLimitPercent,
  } = bunja.use(tpslModalInputBunja);

  function onLimitPriceInputChange(value: string): void {
    setLimitPriceInputText(value, true);
  }

  return {
    pricePrecisionAtom,
    quoteCurrencyAtom,
    limitPriceInputTextAtom,
    limitSecondaryAtom,
    onLimitPriceInputChange,
    onLimitSecondaryChange,
    addLimitPercent,
    tpslType,
    sideAtom,
  };
});
limitPriceInputBunja.debugLabel = 'limitPriceInputBunja';
